import { useSelector } from 'react-redux';
import MessagingCopy from '../messaging/MessagingCopy';
import { DataOptions } from '../signup-data/signupDataOptions';
import { getCurrentStep, getNextSteps } from '../store/flow/selectors';
import { ButtonsGrid } from '../views-components/ButtonsGrid';
import { StepTitle } from '../views-components/StepTitle';
import { usePrivacyBanner } from '../views-components/usePrivacyBanner';
import { BaseView } from './BaseView';
import { getStepConfig } from './getStepConfig';
import { getIsAccountCreationStep } from '../flow-management/getIsAccountCreationStep';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useGTKMSingleFieldReturned } from '../hooks/useGTKMSingleFieldReturned';
import { Data } from 'signup-constants/signupData/Data';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseButtonsView = ({
  onHighlightChange = () => {},
  onSelect = () => {},
  getButtonText,
  getButtonDescriptionText,
  setDataFn,
  type = 'default',
  footer,
  hasNextButton = false,
  nextButtonLabel,
  shouldShowHelperText = true,
  helperTextString,
  helperTextComponent,
  helperTitleKey,
  columnCount,
  optionHeight,
  options,
  isSelected,
  title,
  shouldDisableAutofocus = true,
  preTitle,
  shouldCenterLastRow = true,
  goToNextStep = true,
  shouldShowRecommendedLabel = () => false
}) => {
  const stepKey = useSelector(getCurrentStep);
  const {
    shouldShowToSNonOptionalStep
  } = usePrivacyBanner();
  const {
    gtkmOneFieldReturned,
    gtkmNonDomainKey
  } = useGTKMSingleFieldReturned();
  const defaultHelperText = `views.${stepKey}.helperText`;
  const isAccountCreationStep = useSelector(state => getIsAccountCreationStep(state, getNextSteps(state)));
  const showCreateAccountButton = getFlowConfig().shouldSkipHubletSelectionNewUser && isAccountCreationStep;
  const showNextButtomGTKM = gtkmOneFieldReturned && gtkmNonDomainKey === Data.CompanySize;
  if (!stepKey) {
    return null;
  }
  const stepConfig = getStepConfig(stepKey);
  if (!stepConfig) {
    return null;
  }

  // Supporting only 1 question for now
  const dataKey = stepConfig.data[0];
  const preTitleMessage = preTitle || `views.${stepKey}.pre-title`;
  const helperTextMessage = helperTextString || defaultHelperText;
  const helperText = shouldShowHelperText && (helperTextComponent || /*#__PURE__*/_jsx(MessagingCopy, {
    message: helperTextMessage
  }));
  return /*#__PURE__*/_jsx(BaseView, {
    footer: footer,
    helperText: helperText,
    hideSidePanelNextButton: !showCreateAccountButton && !hasNextButton && !showNextButtomGTKM,
    preTitleMessage: preTitleMessage,
    title: title || /*#__PURE__*/_jsx(StepTitle, {
      message: helperTitleKey,
      stepKey: stepKey
    }),
    children: /*#__PURE__*/_jsx(ButtonsGrid, {
      columnCount: columnCount,
      dataKey: dataKey,
      getButtonDescriptionText: getButtonDescriptionText,
      getButtonText: getButtonText,
      goToNextStep: goToNextStep,
      hasNextButton: hasNextButton || shouldShowToSNonOptionalStep || showCreateAccountButton,
      isSelected: isSelected,
      nextButtonLabel: nextButtonLabel,
      optionHeight: optionHeight,
      options: options || DataOptions[dataKey],
      setDataFn: setDataFn,
      shouldCenter: shouldCenterLastRow,
      shouldDisableAutofocus: shouldDisableAutofocus,
      shouldShowRecommendedLabel: shouldShowRecommendedLabel,
      stepKey: stepKey,
      type: type || shouldShowToSNonOptionalStep && 'radio',
      onHighlightChange: onHighlightChange,
      onSelect: onSelect
    }, dataKey)
  });
};